import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox as CheckboxComponent } from 'semantic-ui-react';
import { groupIsChecked, groupIsIndeterminate } from '../helpers/';

const Checkbox = ({ group, formValues, type, onClick }) => (
  <CheckboxComponent
    checked={groupIsChecked(group, formValues, type)}
    indeterminate={groupIsIndeterminate(group, formValues, type)}
    onClick={onClick}
  />
);

Checkbox.propTypes = {
  group: PropTypes.array.isRequired,
  formValues: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export { Checkbox };



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/components/Checkbox.js